import { Checkbox, FormControl, FormHelperText, TextField } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Fragment } from 'react';

interface ValkyrieSqsQueueSelectorProps {
  value: string[];
  onChange: (value: string[]) => void;
  queueNames: string[];
  label?: string;
  helperText?: string;
  emptyMessage?: string;
}

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export function ValkyrieSqsQueueSelector({
  value,
  onChange,
  queueNames,
  label = 'SQS Queues',
  helperText,
  emptyMessage = 'Add at least one SQS queue in the SQS Queues tab',
}: ValkyrieSqsQueueSelectorProps) {
  const selected = value.filter(q => queueNames.includes(q));

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={queueNames}
        value={selected}
        onChange={(_e, newValue) => onChange(newValue ?? [])}
        size="small"
        renderOption={(option, { selected: isSelected }) => (
          <Fragment>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={isSelected}
            />
            {option}
          </Fragment>
        )}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={queueNames.length === 0 ? emptyMessage : 'Select queues...'}
          />
        )}
        noOptionsText={queueNames.length === 0 ? emptyMessage : 'No queues'}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
